const RandomTable = require('./_scripts/randomTable.js');
const RandomRoll = require('./_scripts/randomRoll.js');

(function () {
  // Rolling on random tables
  const simpleTables = document.querySelectorAll('.__randomTable');
  [...simpleTables].forEach((table) => {
    new RandomTable(table);
  });

  // Custom rolls
  const customTables = document.querySelectorAll('.__randomRoll');
  [...customTables].forEach((table) => {
    new RandomRoll(table);
  });
})();
